import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Icon,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Flex,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

const RejectedFileWarning = ({ isOpen, onClose, onConfirm, fileName }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bg="red.50" color="red.700">
          <Flex align="center">
            <Icon as={WarningIcon} color="red.500" mr={2} />
            Rejected File Warning
          </Flex>
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody py={6}>
          <VStack spacing={4} align="stretch">
            <Alert status="warning" variant="left-accent" borderRadius="md">
              <AlertIcon />
              <Box>
                <AlertTitle>This file has been rejected</AlertTitle>
                <AlertDescription fontSize="sm">
                  Editing this file will change its status to 'submitted' and it
                  will require re-approval.
                </AlertDescription>
              </Box>
            </Alert>

            <Text>
              <strong>File:</strong> {fileName || 'Selected file'}
            </Text>

            <Text fontSize="sm" color="gray.600">
              Are you sure you want to edit this rejected file? After saving, it
              will be resubmitted for approval.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="orange" onClick={onConfirm}>
            Yes, Edit Anyway
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RejectedFileWarning;
